module.exports = __webpack_public_path__ + "assets/img/btn-view-3d5599d7.png";